import { environment } from "src/environments/environment"
import brandInfo from '../environments/brand.json'

export default {
    oidc: brandInfo.okta ? environment.oktaConfig.filter((config: any) => config.brandName === brandInfo.brand)[0] : null
}